export const useNavigationCssClasses = ({ collapsed, active, disabled, } = {}) => {
    const nav = ['sidebar'];
    const navLogo = ['sidebar__logo'];
    const navButtons = ['sidebar__bottom-buttons'];
    const navList = ['sidebar__list'];
    const navItem = ['nav-item'];
    const navItemWrapper = ['nav-item__wrapper'];
    const navItemIcon = ['nav-item__icon'];
    const navItemLabel = ['nav-item__label'];
    const navSubItem = ['nav-sub-item'];
    const navSubItemBullet = ['nav-sub-item__bullet'];
    const navLinkButton = ['nav-link-button'];
    if (collapsed) {
        nav.push('sidebar--collapsed');
        navLogo.push('sidebar__logo--collapsed');
        navButtons.push('sidebar__bottom-buttons--collapsed');
        navItem.push('nav-item--collapsed');
        navItemLabel.push('nav-item__label--collapsed');
        navItemWrapper.push('nav-item__wrapper--collapsed');
        navSubItem.push('nav-sub-item--collapsed');
        navLinkButton.push('nav-link-button--collapsed');
    }
    if (active) {
        navItem.push('nav-item--active');
        navSubItemBullet.push('nav-sub-item__bullet--active');
    }
    if (disabled) {
        navItem.push('nav-item--disabled');
        navLinkButton.push('nav-link-button--disabled');
    }
    return {
        navCss: nav.join(' '),
        navButtonsCss: navButtons.join(' '),
        navListCss: navList.join(' '),
        navItemCss: navItem.join(' '),
        navItemIconCss: navItemIcon.join(' '),
        navItemLabelCss: navItemLabel.join(' '),
        navItemWrapperCss: navItemWrapper.join(' '),
        navLogoCss: navLogo.join(' '),
        navSubItemCss: navSubItem.join(' '),
        navSubItemBulletCss: navSubItemBullet.join(' '),
        navLinkButtonCss: navLinkButton.join(' '),
    };
};
//# sourceMappingURL=useNavigationCssClasses.js.map